import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export const fmtEur = (v) => `${Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
export const fmtDate = (iso) => (iso ? new Date(String(iso).length <= 10 ? `${iso}T12:00:00` : iso).toLocaleDateString('fr-FR') : '—');

export const openGedDoc = async (gedId, headers) => {
  const win = window.open('', '_blank');
  try {
    const r = await axios.get(`${API}/api/ged/documents/${gedId}/download?mode=view`, { headers, responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    if (win) win.location.href = url; else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    if (win) win.close();
    toast.error('Document indisponible');
  }
};
